// extracted by mini-css-extract-plugin
export var column = "TagsLayout-module--column--d92df";
export var columnsWrapper = "TagsLayout-module--columnsWrapper--fcd88";
export var cost = "TagsLayout-module--cost--d5665";
export var costHint = "TagsLayout-module--costHint--4472a";
export var costSum = "TagsLayout-module--costSum--83032";
export var elements = "TagsLayout-module--elements--3c89c";
export var elementsEmpty = "TagsLayout-module--elementsEmpty--a558a";
export var fadeInAnimation = "TagsLayout-module--fadeInAnimation--37049";
export var tag = "TagsLayout-module--tag--b05d9";
export var tagsTitle = "TagsLayout-module--tagsTitle--eace6";
export var wrapper = "TagsLayout-module--wrapper--9e911";